import styled, { CSSProperties, keyframes } from 'styled-components'

interface StyledDropzoneProps {
  center?: string,
  [prop: string]: any
  $maxWidthDropZone?: CSSProperties['width']
}

const fadeInUp = keyframes`
  from {
    opacity: 0;
    transform: translateY(10px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
`

export const StyledDropzone = styled.section<StyledDropzoneProps>`
width: 100%;
max-width: ${props => props?.$maxWidthDropZone ?? '250px'};
min-height: 140px;
border-width: 1px;
display: flex;
align-items: center;
justify-content: center;
cursor: pointer;
border-color: rgba(34,36,38,.15);
border-style: dashed;
border-width: 2px;
border-radius: 5px;
padding: 10px;
position: relative;
animation: ${fadeInUp} 0.3s ease forwards;

&:hover {
  border-color: #85b7d9 !important;
}

.uploadContainer {
  display: flex;
  align-items: center;
  flex-direction: column;
  gap: 5px;
  font-weight: bold;
  i {
    color: #3194d8;
    font-size: 50px;
 }
}


&.group-excluded {
  color: rgba(122, 122, 30, .9);
  background-color: rgba(255, 255, 122, .1);
  background-repeat: no-repeat;
  background-position: center;
  background-size: 80px;
}

> p {
  position: absolute;
  bottom: 0;
  left: 0;
  width: 100%;
  text-align: center;
}
`
